export const PHASE_LABEL = {
  PRESEASON: "Pretemporada",
  COMPETITION: "Competición",
  UNASSIGNED: "Fase pendiente",
};

export const PHASE_BADGE = {
  PRESEASON: "bg-amber-100 text-amber-800",
  COMPETITION: "bg-emerald-100 text-emerald-700",
  UNASSIGNED: "bg-slate-100 text-slate-500",
};

export const phaseLabel = (p) => PHASE_LABEL[p] || PHASE_LABEL.UNASSIGNED;
export const phaseBadge = (p) => PHASE_BADGE[p] || PHASE_BADGE.UNASSIGNED;
